var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('h1',{staticClass:"home-title"},[_vm._v("Adman Awards & Symposium")]),_c('Date'),_c('Sponsor')],1)}
var staticRenderFns = []

export { render, staticRenderFns }